/**
 * Webflow's active-link class, as a function of the route.
 *
 * Webflow marks the current page's nav item with `w--current`. The capture had
 * it written into whichever link matched the page it was captured from, so
 * every page shipped a header and footer that differed from the others by
 * exactly that — 16 of 59 headers and 12 of 59 footers, for nothing.
 *
 * `NavLink` supplies `aria-current="page"` on its own; this supplies the class.
 */
export function wfActive(base: string) {
  return ({ isActive }: { isActive: boolean }) => (isActive ? `${base} w--current` : base)
}
